
import { useUiStore } from "../stores/uiStore";
import type { DragPreviewState } from "../stores/types";

/** Drag-to-scene preview state */
export function useDragPreview() {
  const dragPreview = useUiStore((s) => s.dragPreview);
  const setDragPreview = useUiStore((s) => s.setDragPreview);
  const updateDragPosition = useUiStore((s) => s.updateDragPosition);

  return {
    dragPreview,
    setDragPreview,
    updateDragPosition,
  };
}

export type { DragPreviewState };
